import { render, staticRenderFns } from "./AppliedCertificates.vue?vue&type=template&id=f7775a52&scoped=true"
import script from "./AppliedCertificates.vue?vue&type=script&lang=js"
export * from "./AppliedCertificates.vue?vue&type=script&lang=js"
import style0 from "./AppliedCertificates.vue?vue&type=style&index=0&id=f7775a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7775a52",
  null
  
)

export default component.exports